import { render, staticRenderFns } from "./EditUserBadgeFormDialogComponent.vue?vue&type=template&id=45c7ea02&"
import script from "./EditUserBadgeFormDialogComponent.vue?vue&type=script&lang=js&"
export * from "./EditUserBadgeFormDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditUserBadgeFormDialogComponent.vue?vue&type=style&index=0&id=45c7ea02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports